import { WifiOff, RefreshCw } from 'lucide-react';

type ConnectionErrorProps = {
  onRetry?: () => void;
  message?: string;
};

const ConnectionError = ({
  onRetry,
  message = 'Не удалось подключиться к серверу. Проверьте интернет-соединение.'
}: ConnectionErrorProps) => {
  return (
    <div className="flex items-center justify-center w-full py-[15px]" data-name="connection-error">
      <div className="flex flex-col gap-[12px] px-[16px] py-[14px] bg-[#fef2f2] border border-[#fecaca] rounded-[10px] max-w-[85%]">
        {/* Header with icon */}
        <div className="flex items-start gap-[10px]">
          <WifiOff className="w-[20px] h-[20px] text-[#dc2626] shrink-0 mt-[2px]" />
          <div className="flex-1 flex flex-col gap-[6px]">
            <p className="font-['Manrope:Medium',sans-serif] font-medium leading-[1.4] text-[#991b1b] text-[14px]">
              Ошибка подключения
            </p>
            <p className="font-['Manrope:Regular',sans-serif] font-normal leading-[1.5] text-[#991b1b] text-[13px]">
              {message}
            </p>
          </div>
        </div>

        {/* Retry button */}
        {onRetry && (
          <button
            onClick={onRetry}
            className="flex items-center justify-center gap-[6px] px-[14px] py-[8px] bg-white border border-[#fecaca] rounded-[8px] hover:bg-[#fef2f2] transition-colors self-start"
          >
            <RefreshCw className="w-[16px] h-[16px] text-[#dc2626]" />
            <p className="font-['Manrope:Medium',sans-serif] font-medium text-[#dc2626] text-[13px]">
              Повторить попытку
            </p>
          </button>
        )}
      </div>
    </div>
  );
}

export default ConnectionError;